import React from 'react'
import Video from '../Video';
import Assetblock from '../Assetblock';
import Iframe from '../Iframe';
import { generateKey } from '../../../utils/utils.js'
import HyperLink from './HyperLink'

const RichText = ({ content, index }) => {
    if (content.value === "") {
        return;
    }
    else if (content.type) {
        return content
    }
    if (content.nodeType === "embedded-asset-block") {
        return <Assetblock content={content} key={generateKey(index)} index={index} />
    } else if (content.nodeType === "paragraph" && content.content[0].value.includes('iframe')) {
        return <Iframe content={content} autoplay={1} key={generateKey(index)} index={index} />
    } else if (content.nodeType === "paragraph" || content.nodeType === "text") {
        if (content.content[0].value.includes('youtube') || content.content[0].value.includes('vimeo')) {
            return <Video content={content} key={generateKey(index)} index={index} />
        }
        else if (content.content.length > 1) {
            return <HyperLink content={content} />
        } else {
            return <p key={generateKey(index)}>{content.content[0].value} </p>
        }
    } else if (content.nodeType && content.nodeType.includes("heading")) {
        return <h1 key={generateKey(index)}>{content.content[0].value} </h1>
    }
}

export default RichText;


// WEBPACK FOOTER //
// ./src/Posts/elements/Components/RichText.js